module.exports = __webpack_public_path__ + "static/automata-b39fb918fe98750c08d0c7739c8e4c37.gif";